"use strict";
/**
 * Font Awesome conditional loading
 * Only loads the icon variants that are actually used on the page
 *
 * @package StandOut
 * @since 2.0.0
 */
window.addEventListener("load", () => {
    const fontawesome = document.querySelectorAll("[class^=fa-]");
    if (fontawesome.length > 0) {
        // Import base Font Awesome CSS
        import("../../css/libraries/fontawesome/fontawesome.css").then(() => {
            // Conditionally load icon variants based on usage
            const solid = document.querySelectorAll("[class^=fa-solid]");
            if (solid.length > 0) {
                import("@fortawesome/fontawesome-pro/css/solid.min.css");
            }
            const regular = document.querySelectorAll("[class^=fa-regular]");
            if (regular.length > 0) {
                import("@fortawesome/fontawesome-pro/css/regular.min.css");
            }
            const light = document.querySelectorAll("[class^=fa-light]");
            if (light.length > 0) {
                import("@fortawesome/fontawesome-pro/css/light.min.css");
            }
            const duotone = document.querySelectorAll("[class^=fa-duotone]");
            if (duotone.length > 0) {
                import("@fortawesome/fontawesome-pro/css/duotone.min.css");
            }
            const thin = document.querySelectorAll("[class^=fa-thin]");
            if (thin.length > 0) {
                import("@fortawesome/fontawesome-pro/css/thin.min.css");
            }
        });
    }
});
